import {useEffect} from 'react'

import {AppRouter} from '@/router/AppRouter'
import {DeploymentMeta} from '@/components/DocumentMeta'
import {LoginModal} from '@/components/LoginModal'
import {cleanupUserStore, initializeUserStore} from '@/stores/user'

export function App() {
  useEffect(() => {
    initializeUserStore()
    return cleanupUserStore
  }, [])

  return <><DeploymentMeta /><AppRouter /><LoginModal /></>
}
